var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{fill:#FAFAFA;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#F0F0F0;}\n\t.st5{fill:#FFFFFF;}\n\t.st6{display:none;}\n\t.st7{display:inline;}\n\t.st8{fill:#E58A7B;}\n\t.st9{fill:#407BFF;}\n\t.st10{opacity:0.2;}\n\t.st11{fill:#E8ECF1;}\n\t.st12{fill:#263238;}\n\t.st13{fill:#CF6F64;}\n\t.st14{fill:#DF5753;}\n\t.st15{opacity:0.56;fill:#FAFAFA;}\n\t.st16{opacity:7.000000e-002;fill:#407BFF;}\n\t.st17{opacity:0.47;fill:#407BFF;}\n\t.st18{opacity:0.1;fill:#FFFFFF;}\n\t.st19{opacity:0.6;}\n\t.st20{opacity:0.4;}\n\t.st21{opacity:0.4;fill:#FFFFFF;}\n\t.st22{opacity:0.3;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background_complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    className: "st0",
    width: 500,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.7,
    y: 397.5,
    className: "st0",
    width: 33.1,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 397.5,
    className: "st0",
    width: 19.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.4,
    y: 401.2,
    className: "st0",
    width: 19.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.4,
    y: 406.8,
    className: "st0",
    width: 43.2,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.2,
    y: 406.8,
    className: "st0",
    width: 6.3,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.7,
    y: 401.2,
    className: "st0",
    width: 93.7,
    height: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237,337.8H43.9c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7H237c3.1,0,5.7,2.6,5.7,5.7v271.4 C242.7,335.2,240.2,337.8,237,337.8z M43.9,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5H237c3,0,5.5-2.4,5.5-5.5V60.7 c0-3-2.4-5.5-5.5-5.5H43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M453.3,337.8H260.2c-3.1,0-5.7-2.6-5.7-5.7V60.7c0-3.1,2.6-5.7,5.7-5.7h193.1c3.1,0,5.7,2.6,5.7,5.7v271.4 C459,335.2,456.5,337.8,453.3,337.8z M260.2,55.2c-3,0-5.5,2.4-5.5,5.5v271.4c0,3,2.4,5.5,5.5,5.5h193.1c3,0,5.5-2.4,5.5-5.5 V60.7c0-3-2.4-5.5-5.5-5.5H260.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 245.4,
    y: 297,
    className: "st1",
    width: 22,
    height: 87.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "263.2,384.2 267.4,384.2 267.4,372.3 258.8,372.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.1,
    y: 297,
    className: "st1",
    width: 22,
    height: 87.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.4,
    y: 297,
    className: "st2",
    width: 100,
    height: 79.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.8,300.9v21.2H171v-21.2H263.8 M264.2,300.5h-93.5v21.9h93.5V300.5L264.2,300.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "171.6,384.2 167.4,384.2 167.4,372.3 176,372.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 217.4,
    cy: 311.5,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.8,326.4v21.2H171v-21.2H263.8 M264.2,326h-93.5v21.9h93.5V326L264.2,326z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 217.4,
    cy: 336.9,
    r: 2.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.8,351.8V373H171v-21.2H263.8 M264.2,351.5h-93.5v21.9h93.5V351.5L264.2,351.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 217.4,
    cy: 362.4,
    r: 2.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 135.6,
    y: 246.3,
    className: "st1",
    width: 22,
    height: 137.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "153.4,384.2 157.6,384.2 157.6,372.3 149.1,372.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4,
    y: 246.3,
    className: "st1",
    width: 22,
    height: 137.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 246.3,
    className: "st2",
    width: 85.8,
    height: 130.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.9,250v29.6H75.5V250H153.9 M154.4,249.6H75V280h79.3V249.6L154.4,249.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M153.9,283.2v78.4h-37.4v-78.4H153.9 M154.4,282.7h-38.3v79.3h38.3V282.7L154.4,282.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.8,283.2v78.4H75.5v-78.4H112.8 M113.3,282.7H75v79.3h38.3V282.7L113.3,282.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "76,384.2 71.8,384.2 71.8,372.3 80.3,372.3  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 114.7,
    cy: 264.8,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 122.6,
    cy: 320.5,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 106.8,
    cy: 320.5,
    r: 2.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.1,207.9h-9.3c0,0,1.6,8.6,1.6,13.6c0,5-7.1,24.8,3,24.8c10.1,0,3-19.8,3-24.8 C100.5,216.4,102.1,207.9,102.1,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.8,228.1v6c0,6.7,5.5,12.1,12.1,12.1h6c6.7,0,12.1-5.5,12.1-12.1v-6H66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.7,284.3c0,7,7.8,12.7,17.4,12.7h8.6c9.6,0,17.4-5.7,17.4-12.7H195.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M424.6,274c-5.2,4.3-12.5,12.1-19.1,23.1c-4.4,7.3-7.1,15-8.2,25.2c0-11.5,0.1-23.9,0.1-35.5 c1.3-3,4.4-9.9,6.6-15.4c7.3-18.2,10-22.7,16.5-38.4c8.7-21,17.7-45.9,15.1-43.9c-5.2,4.1-25.2,41.5-27.4,46.9 c-7.4,18.4-9.5,31.9-10.8,44.9c0-11,0.1-21,0.1-28.8c0.1-25.3,0.6-33.5,0.8-36c0.8-1.3,1.8-2.8,2.3-3.6 c4.7-6.8,6.5-12.6,10.9-22.7c6.3-14.4,11.7-39.8,10.1-38.6c-6.6,5.4-11.8,16.9-18.6,31.5c-6.8,14.7-4.9,23.1-6.2,35.6 c-0.3,2.5-0.5,11.7-0.7,24.6c-1.8-13.7-5.1-22.7-11.1-30.9c-7.4-10.1-14.6-16.9-19.9-20.5c-5.3-3.6,9.1,21.2,16,32 c6.1,9.6,11.8,18.1,15,26.5c-0.2,17.4-0.2,39.5-0.2,60c-1.6-9.3-4.2-19.4-7.6-27.2c-4.1-9.4-10.5-23.7-15.6-28.6 c-1.2-1.2,5.3,26.8,9.5,34.2c4.2,7.4,7.2,14.4,9.9,18.6c0.6,1,2.6,4.8,3.8,6.9c0,25.1,0.1,47.2,0.4,54.7h1.1 c-0.1-1.9-0.1-14.7-0.1-31.6c2.6-9.2,8.6-19.6,13.5-29.2C416.1,297.7,429.8,269.8,424.6,274z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "412.4,384.2 381.1,384.2 378.7,353.5 414.8,353.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "417.1,357.1 376.4,357.1 375.2,346.7 418.3,346.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 68.2,
    y: 75.5,
    className: "st1",
    width: 56.1,
    height: 61.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.4,
    y: 75.5,
    className: "st3",
    width: 57.9,
    height: 61.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 80.3,
    className: "st5",
    width: 48.2,
    height: 51.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 92.9,
    className: "st3",
    width: 24.8,
    height: 26.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 358,
    y: 82.7,
    className: "st1",
    width: 52.1,
    height: 57.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.9,
    y: 82.7,
    className: "st3",
    width: 53.8,
    height: 57.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.4,
    y: 87.2,
    className: "st5",
    width: 44.8,
    height: 48.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 388.8,
    cy: 111.3,
    r: 14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.9,
    y: 112.2,
    className: "st1",
    width: 41.6,
    height: 45.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 112.2,
    className: "st3",
    width: 42.9,
    height: 45.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.6,
    y: 115.8,
    className: "st5",
    width: 35.8,
    height: 38.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "165.5,125.3 155.7,142.2 175.3,142.2  "
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Background_simple",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M134.5,237.7c58.5,60.4,135.5,102.2,206.8,34.6c36.8-34.8,85.3-128.9,37.4-172 c-66.1-59.3-104,37.8-153.4,50.9c-33.9,9-62.3-43-102.9-8.3C90.4,170.5,110.1,212.7,134.5,237.7z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 250,
    cy: 416.2,
    rx: 193.9,
    ry: 11.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M349.2,163.4l-9.9-4c0,0-13.1,23.9-16.8,25.1c-5.1,1.6-15.7,6.2-21.9,7.1c-0.8,1-2.2,4.1-2.1,5.2 c8.4,2.8,26.9-0.9,30.8-3.9C338.3,186.2,349.2,163.4,349.2,163.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M352.3,158c1.8,6.8-8.2,20.6-8.2,20.6l-13.2-7.4c0,0,2.5-5.6,5.5-11.4C341.3,150.5,350.2,150.2,352.3,158z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M352.3,158c1.8,6.8-8.2,20.6-8.2,20.6l-13.2-7.4c0,0,2.5-5.6,5.5-11.4C341.3,150.5,350.2,150.2,352.3,158z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M336.2,174.1l5.2,2.9l0.9-15.9C339.3,163.5,337.2,170.4,336.2,174.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M343.7,152.9c0,0-10.2,22.7-4.3,65.1c12.1,0,34.4,0,40.3,0c0.6-6.2-1.5-36.3,6.2-65.5c0,0-6.8-1.4-13.4-1.7 c-5.1-0.2-12.6-0.4-17.1,0C349.4,151.3,343.7,152.9,343.7,152.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M343.7,152.9c0,0-10.2,22.7-4.3,65.1c12.1,0,34.4,0,40.3,0c0.6-6.2-1.5-36.3,6.2-65.5c0,0-6.8-1.4-13.4-1.7 c-5.1-0.2-12.6-0.4-17.1,0C349.4,151.3,343.7,152.9,343.7,152.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M334.3,417.1c-0.1,1.1,15.2,1.9,34.1,1.9s34.3-0.9,34.3-1.9c0.1-1.1-15.2-1.9-34.1-1.9 C349.8,415.2,334.4,416.1,334.3,417.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "368.3,406.1 361.2,408.9 355,392.9 362.2,390.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "393.1,409.5 385.5,409.5 382.8,392 390.3,392  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M385,408.6l8.5,0c0.3,0,0.6,0.2,0.6,0.5l1.1,6.7c0.1,0.7-0.5,1.4-1.2,1.3c-3-0.1-4.4-0.2-8.1-0.2 c-2.3,0-7,0.2-10.2,0.2c-3.1,0-3.4-3.1-2.1-3.4c5.9-1.3,8.2-3,10.1-4.7C384.1,408.7,384.6,408.6,385,408.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M360,405.9l8-2.3c0.3-0.1,0.6,0,0.7,0.3l3,6c0.3,0.6-0.1,1.4-0.8,1.6c-2.9,0.8-4.9,1.3-8.5,2.3 c-2.5,0.7-5.1,1.9-7.6,2.7c-1.7,0.5-5.8,0.6-7.8,0.6c-3.1,0-3.8-3.3-2.5-3.4c3.4-0.4,3.8-0.2,5.7-1.1c3.1-1.5,5.4-2.8,8.1-5.6 C358.8,406.5,359.3,406.1,360,405.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M301.8,191.5l-8.3-3.5l-3.4,9.2c0,0,4.8,0.9,10.2,0L301.8,191.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "287.4,187.8 287.2,193.9 290.1,197.2 293.5,188  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "355,392.9 358.2,401.1 365.3,398.4 362.2,390.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "390.3,392 382.8,392 384.2,401 391.7,401  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M338.1,206.5c0.1,1.8,0.3,3.7,0.5,5.6l29.9-9.7c4.7-1.4,8.7-4.3,11.5-8.4c0.1-2.7,0.3-5.5,0.5-8.4 c0.1-1.4,0.2-2.9,0.4-4.4c0.1-1.5,0.3-3.1,0.5-4.7L338.1,206.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M347.9,173.7l-1-0.1c0.6-5,4.3-8.9,8.3-8.8l0,1C351.7,165.7,348.4,169.2,347.9,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M353.2,182.9c-0.1,0-0.1,0-0.2,0l0-1c3.4,0.1,6.7-3.5,7.2-7.9l1,0.1C360.7,179,357.1,182.9,353.2,182.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M371.9,131.5c-1.4,5.5-3.1,15.6,0.6,19.3c0,0-2.5,5.6-12.8,5.6c-9.4,0-4.3-5.6-4.3-5.6 c6.2-1.5,6.3-6,5.5-10.3L371.9,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M367.4,135.2l-6.5,5.3c0.2,1,0.3,2,0.3,3c1.9,1.9,5.7-2.9,6.1-5.4C367.6,136.9,367.6,135.7,367.4,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M349.7,131.4c1,1.7,2.6,2.8,4.2,3.1c2.4,0.5,3.6-1.7,2.9-3.9c-0.6-2-2.6-4.7-5-4.2 C349.5,126.9,348.6,129.5,349.7,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M353.6,113.8c-3.7,1.7-5.1,16.6-0.4,18.8C358,134.8,360.7,110.6,353.6,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M373.1,123.2c-0.9,7.5-1,11.8-5,15.7c-6,5.8-15,2.3-16.4-5.1c-1.2-6.7,0.5-17.8,7.9-20.7 C367,110.1,374,115.8,373.1,123.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M360.8,117.7c5.5-1.4,9.6-2.4,8.2,2.2c-1.9,6.2-4.3,12.1-1.1,12.4c1.9,0.2,10.3-3.4,9.2-7 c-0.9-3.1,3-4,3.7-5.6c2.6-5.8-4.8-5-3.5-8.5c1.3-3.4-6-9.1-10-6.3c-6.5,4.5-17.7,4.5-11.8-3c4.2-5.3-3.3-4.2-3.3-4.2 s4.5,2.7-3.1,6.9C340.9,108.9,348.3,120.8,360.8,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M375.9,131.4c-1.2,1.7-3,2.8-4.6,3.1c-2.5,0.5-3.4-1.7-2.5-3.9c0.8-2,3.1-4.7,5.5-4.2 C376.6,126.9,377.3,129.5,375.9,131.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M339.4,217.9c0,0-6.8,60.5-7.3,83.5c-0.5,23.9,22.9,98.4,22.9,98.4l12-5c0,0-14-68.1-12-91.5 c2.1-25.6,10.9-85.3,10.9-85.3H339.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M356.2,234.6c-5.4,11.2-1.8,33.3,1.2,46.4c1.1-9.2,2.4-19.3,3.7-28.6C360.9,238.1,359.8,227,356.2,234.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M366.5,390.8c0.1,0,1.4,3.8,1.4,3.8l-13.8,5.8l-2.2-4.1L366.5,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M353.7,217.9c0,0,5.2,57.5,8.6,79.1c3.8,23.6,18.5,102.2,18.5,102.2h13.8c0,0-8.3-76.7-9.8-100.1 c-1.7-25.4-5.1-81.2-5.1-81.2H353.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M394.8,395.7c0.1,0,0.5,3.9,0.5,3.9h-15.2l-1.1-4.4L394.8,395.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M389.5,391.1c-0.1,0-0.1,0-0.1-0.1c-0.1-0.7-7.5-70-8.9-91c-1.5-22.8-4.6-73.3-4.6-73.8 c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.1c0,0.5,3.1,51,4.6,73.8c1.4,21,8.9,90.3,8.9,91 C389.6,391.1,389.6,391.1,389.5,391.1C389.5,391.1,389.5,391.1,389.5,391.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M361.6,125.3c0,0.6-0.4,1.1-0.8,1.1c-0.4,0-0.7-0.5-0.7-1.1c0-0.6,0.4-1.1,0.8-1.1 C361.4,124.2,361.7,124.7,361.6,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M354.8,125.3c0,0.6-0.4,1.1-0.8,1.1s-0.7-0.5-0.7-1.1c0-0.6,0.4-1.1,0.8-1.1 C354.5,124.2,354.8,124.7,354.8,125.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M356.9,125.6c0,0-1.6,3.5-3.2,5.2c1,1,2.9,0.5,2.9,0.5L356.9,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M357.1,133.9c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2c2.7,0,4-1.9,4-1.9c0.1-0.1,0.2-0.1,0.2-0.1 c0.1,0.1,0.1,0.2,0,0.2C361.4,131.9,360,133.9,357.1,133.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M362.8,123.4c-0.1,0-0.2,0-0.3,0c-1.3-0.8-2.5-0.3-2.5-0.3c-0.2,0.1-0.4,0-0.5-0.2c-0.1-0.2,0-0.4,0.2-0.5 c0.1,0,1.6-0.7,3.2,0.3c0.2,0.1,0.2,0.3,0.1,0.5C363,123.4,362.9,123.4,362.8,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M352.1,121.5c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.4,0-0.5c1.4-1.5,3-1.3,3.1-1.2c0.2,0,0.3,0.2,0.3,0.4 c0,0.2-0.2,0.3-0.4,0.3l0,0c-0.1,0-1.3-0.2-2.4,1C352.4,121.5,352.2,121.5,352.1,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M389.7,162.3l-10.4-2.8c0,0-10.2,25.1-13.8,26.7c-4.9,2.2-17.3,9.9-22.6,13.7c-0.3,1.2-0.1,4.6,0.6,5.5 c9-1.6,26.2-8.3,29.8-11.6C381.6,186.1,389.7,162.3,389.7,162.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M382.5,409.9c-0.6,0-1.1-0.1-1.4-0.4c-0.3-0.2-0.4-0.5-0.3-0.9c0-0.3,0.2-0.4,0.3-0.5 c0.8-0.4,3.2,1.1,3.5,1.2c0.1,0,0.1,0.1,0.1,0.2c0,0.1-0.1,0.1-0.1,0.1C383.9,409.8,383.2,409.9,382.5,409.9z M381.4,408.3 c-0.1,0-0.2,0-0.2,0c0,0-0.1,0.1-0.1,0.2c0,0.3,0,0.5,0.2,0.6c0.4,0.3,1.4,0.4,2.7,0.1C383.1,408.9,382,408.3,381.4,408.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M384.4,409.6C384.4,409.6,384.4,409.6,384.4,409.6c-0.8-0.4-2.2-2.1-2-2.9c0-0.2,0.2-0.4,0.6-0.5 c0.3,0,0.5,0,0.7,0.2c0.8,0.7,0.9,2.9,0.9,3C384.6,409.5,384.6,409.6,384.4,409.6C384.5,409.6,384.4,409.6,384.4,409.6z  M383.1,406.6C383,406.6,383,406.6,383.1,406.6c-0.3,0-0.3,0.1-0.4,0.2c-0.1,0.5,0.8,1.7,1.5,2.3c-0.1-0.6-0.2-1.9-0.8-2.4 C383.4,406.6,383.2,406.6,383.1,406.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M355.9,408.7c-0.7,0.2-1.4,0.2-1.9,0c-0.3-0.2-0.4-0.4-0.5-0.8c0-0.2,0-0.4,0.2-0.5c0.8-0.7,4.1,0.1,4.4,0.1 c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1-0.1,0.2C357.6,408.1,356.7,408.5,355.9,408.7z M354.3,407.5c-0.1,0-0.2,0.1-0.3,0.1 c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.2,0.1,0.4,0.3,0.5c0.5,0.3,1.8,0.1,3.4-0.6C356.5,407.5,355,407.3,354.3,407.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M358.2,407.8C358.1,407.8,358.1,407.8,358.2,407.8c-1-0.2-3.1-1.3-3.1-2.2c0-0.2,0.1-0.5,0.6-0.6 c0.3-0.1,0.7-0.1,1,0.1c1.1,0.5,1.7,2.5,1.7,2.5C358.3,407.7,358.3,407.7,358.2,407.8C358.2,407.8,358.2,407.8,358.2,407.8z  M355.8,405.3c0,0-0.1,0-0.1,0c-0.3,0.1-0.3,0.2-0.3,0.3c0,0.5,1.4,1.5,2.5,1.8c-0.2-0.6-0.7-1.7-1.4-2 C356.2,405.3,356,405.3,355.8,405.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M343.8,199.4l-10.4,4.8l-1.2,2.9l3.9,2.6c0,0,7.2-0.8,9.2-5.4L343.8,199.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M344.2,205.6c-0.7-3.9-1.9-5.6-1.9-5.7l1.6-1.2c0.1,0.1,1.6,2.1,2.3,6.5L344.2,205.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9271 -0.3747 0.3747 0.9271 -50.4417 143.6641)",
    className: "st12",
    cx: 344.2,
    cy: 201.5,
    rx: 2,
    ry: 1.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "326.3,208 327.7,209.5 337,205.4 333.4,204.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M366.5,390.8c0.1,0,1.4,3.8,1.4,3.8l-13.8,5.8l-2.2-4.1L366.5,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M394.8,395.7c0.1,0,0.5,3.9,0.5,3.9h-15.2l-1.1-4.4L394.8,395.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M392.4,159.4c2.8,8.9-8,21-8,21l-14.8-6.1c0,0,2.1-6.4,6.1-15.1C380.2,149.5,389.7,150.5,392.4,159.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M392.4,159.4c2.8,8.9-8,21-8,21l-14.8-6.1c0,0,2.1-6.4,6.1-15.1C380.2,149.5,389.7,150.5,392.4,159.4z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238.5,
    y: 70.6,
    className: "st9",
    width: 6.4,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.2,
    y: 111.3,
    transform: "matrix(0.999 4.499679e-002 -4.499679e-002 0.999 5.7287 -14.6252)",
    className: "st9",
    width: 1,
    height: 17.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "325.6,75.2 207.6,75.2 196.6,320.9 314.6,320.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "322.1,78.6 204.1,78.6 193.1,324.3 311.1,324.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "318.6,81.9 200.6,81.9 189.6,327.7 307.6,327.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "305.1,189.1 204.4,189.1 203.6,207.9 304.3,207.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "259.8,175.4 205,175.4 204.7,183.8 259.4,183.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "302.9,239.8 202.2,239.8 201.3,258.7 302,258.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "284.4,284 216.7,284 215.7,306.6 283.4,306.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.9,310.1h-67.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1l1-22.5c0-0.1,0.1-0.1,0.1-0.1h67.7c0,0,0.1,0,0.1,0 c0,0,0,0.1,0,0.1l-1,22.5C280,310,279.9,310.1,279.9,310.1z M212.3,309.8h67.5l1-22.3h-67.5L212.3,309.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "248,226.1 202.8,226.1 202.4,234.5 247.6,234.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M283.1,128.4c-0.3,5.6-2.3,10.8-5.6,15.1c-4.9,6.4-12.7,10.6-21.2,10.6c-8.5,0-15.9-4.2-20.2-10.6 c-2.9-4.2-4.5-9.4-4.2-15.1c0.6-14.2,12.6-25.6,26.8-25.6C272.8,102.8,283.7,114.2,283.1,128.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M285.5,108.1c-0.1,1.5-0.6,2.9-1.5,4c-1.3,1.7-3.4,2.8-5.6,2.8s-4.2-1.1-5.4-2.8c-0.8-1.1-1.2-2.5-1.1-4 c0.2-3.8,3.4-6.8,7.1-6.8C282.8,101.3,285.7,104.4,285.5,108.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M215.3,198.5c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3 C214.1,195.5,215.3,196.8,215.3,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M228.8,198.5c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3S228.8,196.8,228.8,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M242.2,198.5c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3 C241,195.5,242.3,196.8,242.2,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M213,249.3c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3C211.8,246.2,213.1,247.6,213,249.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M226.5,249.3c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3 C225.3,246.2,226.6,247.6,226.5,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M240,249.3c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3S240,247.6,240,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M253.5,249.3c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3 C252.2,246.2,253.5,247.6,253.5,249.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M266.9,249.3c-0.1,1.7-1.5,3-3.1,3c-1.7,0-3-1.3-2.9-3c0.1-1.7,1.5-3,3.1-3 C265.7,246.2,267,247.6,266.9,249.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M268.2,119.8c-0.3,5.7-5.1,10.4-10.8,10.4c-5.7,0-10.2-4.6-9.9-10.4c0.3-5.7,5.1-10.4,10.8-10.4 C264.1,109.5,268.5,114.1,268.2,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M277.5,143.4c-4.9,6.4-12.7,10.6-21.2,10.6c-8.5,0-15.9-4.2-20.2-10.6c4.9-4.8,12.6-8,21.1-8 C265.7,135.4,273.1,138.6,277.5,143.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M268.2,119.8c-0.3,5.7-5.1,10.4-10.8,10.4c-5.7,0-10.2-4.6-9.9-10.4c0.3-5.7,5.1-10.4,10.8-10.4 C264.1,109.5,268.5,114.1,268.2,119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M277.5,143.4c-4.9,6.4-12.7,10.6-21.2,10.6c-8.5,0-15.9-4.2-20.2-10.6c4.9-4.8,12.6-8,21.1-8 C265.7,135.4,273.1,138.6,277.5,143.4z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Character_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M130.4,212.4c-0.9,2.1-1.9,4.4-2.8,6.6c-0.9,2.2-1.8,4.5-2.5,6.8c-1.5,4.6-2.9,9.2-3.6,13.8l-0.2,1.5 c0,0.2,0,0.4,0.1,0.7c0.1,0.6,0.5,1.5,1.1,2.3c1.1,1.7,2.7,3.4,4.4,5c1.7,1.6,3.6,3.2,5.5,4.6c1.9,1.5,3.9,2.9,5.9,4.3l-1.9,3.5 c-4.8-2.1-9.2-4.6-13.5-7.7c-2.1-1.6-4.2-3.3-6-5.7c-0.9-1.2-1.8-2.5-2.4-4.3c-0.3-0.9-0.5-1.9-0.5-2.9c0-0.2,0-0.6,0-0.8l0-0.5 l0.1-1c0.5-5.3,1.7-10.4,3.3-15.3c0.8-2.5,1.6-4.9,2.6-7.3c1-2.4,1.9-4.7,3.1-7.2L130.4,212.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M136.9,257.4l7.1-3.6l-1.8,7.8c0,0-4.9,1.4-7.1-1L136.9,257.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "150.5,255.1 148.6,261.5 142.2,261.6 144,253.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M160.4,175c0,0,0.6,2.3,1.6,4c-0.8,0.8-1.6,0.5-1.6,0.5V175z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 160.2,
    cy: 173.9,
    rx: 0.7,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M160,172.8l1.5-0.4C161.6,172.4,160.8,173.6,160,172.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M140.9,182.3c0.9,4.7,1.8,13.2-1.4,16.3c0,0,1.3,4.7,9.9,4.7c9.5,0,4.5-4.7,4.5-4.7 c-5.2-1.2-5.1-5.1-4.2-8.7L140.9,182.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M138.4,171.7c0.5,7.8,0.5,11.1,4.4,15.1c5.9,6,15.3,3.7,17.2-4c1.7-7,0.6-18.5-7-21.6 C145.5,158.1,137.9,164,138.4,171.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139.1,162.9c-3.9,1.4-9.1,0.4-7.1,12.4c2.2,12.7-1.2,16.9-1.2,16.9s14.8,3.2,29.9-0.2 c0,0-4.6-8.1-3.3-13.9c1.6-7.5,0.3-10.3,0.3-10.3S144.6,161,139.1,162.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M155.6,175.8c0,1.5,0.5,3.1,1.2,4.2c1.1,1.6,2.3,1,2.6-0.7c0.3-1.5,0.1-4.2-1.3-5.2 C156.9,173,155.7,174,155.6,175.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M135.8,164.3c-1.1-3.1,4.2-8,15.5-6c11.3,2,11.8,11.4,11.8,11.4l-2.3-2.7l0.1,2.9l-11.6,2.2L135.8,164.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.7,199.2L136.7,199.2c-0.2-1,0.5-1.9,1.5-2c3.5-0.6,11.5-1.8,15.5-1.2c3,0.4,3.8,2.2,3.9,3.6 c0.1,1.1-0.8,2-1.8,1.9l-17.4-0.8C137.5,200.6,136.8,200,136.7,199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M136.7,199.2L136.7,199.2c-0.2-1,0.5-1.9,1.5-2c3.5-0.6,11.5-1.8,15.5-1.2c3,0.4,3.8,2.2,3.9,3.6 c0.1,1.1-0.8,2-1.8,1.9l-17.4-0.8C137.5,200.6,136.8,200,136.7,199.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "146.8,373.9 153.2,378.3 164,363.7 157.6,359.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "131.7,373.6 138.5,377.4 148.1,362 141.3,358.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "164,363.7 158.4,371.3 152,366.8 157.5,359.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "141.3,358.1 148.1,362 143.2,370 136.3,366.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M152.2,248c0,0,25.2,31.7,20.5,62.1c-3.8,24.5-25.9,57.7-25.9,57.7l-10.4-5.2c0,0,11.3-22.1,18.7-45.4 c3.1-9.8,1.8-20.6-4-29.1c-12.8-18.6-33.2-7.5-19.4-40.1H152.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M152.2,248c0,0,25.2,31.7,20.5,62.1c-3.8,24.5-25.9,57.7-25.9,57.7l-10.4-5.2c0,0,11.3-22.1,18.7-45.4 c3.1-9.8,1.8-20.6-4-29.1c-12.8-18.6-33.2-7.5-19.4-40.1H152.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M164.5,268.4l-3.7-3.6c0,0.3,7.1,44.1,9.1,56.4c1.2-3.8,2.1-7.5,2.7-11C175,295.2,170.1,280,164.5,268.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M163.4,248c0,0,30.3,39.9,31.2,63.8c0.7,20-33,58.7-33,58.7l-9.8-6.3c0,0,19.7-27.5,24.7-50 c-1.9-22.3-42.5-66.2-42.5-66.2H163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M163.4,248c0,0,30.3,39.9,31.2,63.8c0.7,20-33,58.7-33,58.7l-9.8-6.3c0,0,19.7-27.5,24.7-50 c-1.9-22.3-42.5-66.2-42.5-66.2H163.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M125.9,200.4c-3.2,0.8-6.3,12.6-6.3,12.6l12.7,8.5c0,0,4.2-9.3,2.7-13.4C133.5,203.8,130,199.4,125.9,200.4z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M128.4,208l-0.9,10.3l4.7,3.2c0,0,2.2-4.9,2.9-9.1L128.4,208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.2,200.6c0,0,3.7,1.3-3.7,47.4c-12.6,0-25.7,0-31.9,0c0.5-13,0.5-21-5.6-47.6c0,0,6.7-1.5,13.5-1.8 c5.4-0.3,9.8-0.4,14.5,0C160.1,199.2,167.2,200.6,167.2,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M170.4,207.9c0.7,2,1.5,4.2,2.3,6.2c0.8,2.1,1.6,4.2,2.4,6.3l2.5,6.3l0.6,1.6l0.3,0.8l0.2,0.4 c0,0.1,0,0.1,0,0.1c0,0-0.1-0.2-0.7-0.6c-0.3-0.2-0.8-0.4-1.3-0.4c-0.5,0-0.9,0.1-1.1,0.2c-0.5,0.2-0.5,0.3-0.4,0.3 c0,0,0.1-0.1,0.2-0.2c0.4-0.5,1-1.4,1.4-2.3c0.5-0.9,0.9-1.9,1.4-2.9c0.9-2,1.7-4.1,2.5-6.2c0.8-2.1,1.6-4.2,2.3-6.3l2.3-6.4 l3.9,1c-0.8,4.6-1.7,9-2.9,13.5c-0.6,2.2-1.2,4.5-2,6.7c-0.4,1.1-0.8,2.3-1.3,3.4c-0.5,1.2-1,2.3-1.9,3.6 c-0.2,0.3-0.5,0.7-0.9,1.1c-0.4,0.4-0.8,0.8-1.8,1.3c-0.5,0.2-1.2,0.4-1.9,0.4c-0.8,0-1.6-0.3-2.1-0.6c-1.1-0.7-1.5-1.4-1.8-1.9 c-0.2-0.3-0.3-0.5-0.4-0.7l-0.2-0.4l-0.4-0.8l-0.8-1.6c-1-2.1-2-4.2-2.9-6.3c-0.9-2.1-1.8-4.3-2.7-6.4c-0.8-2.2-1.6-4.3-2.4-6.6 L170.4,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M167.2,200.6c3.8,0.9,8.1,12.2,8.1,12.2l-11.4,9.7c0,0-7.4-12.3-5.9-16.4 C159.6,201.9,162.2,199.4,167.2,200.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M187,201.2l4-3.3l2.8,4.3l-2,3.6c0,0-3.3,3-6.1,1.5l0,0C184.6,205.1,185.2,202.7,187,201.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "198.2,197.9 197.9,198.9 191.6,200 191,197.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "162.4,371.1 151,363.7 153,360.1 165.9,368  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143,376.9c-0.9,0-2.1-0.6-2.8-1c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1-0.2c0.3-0.1,3-0.9,3.8-0.3 c0.1,0.1,0.3,0.3,0.2,0.6c-0.1,0.4-0.2,0.7-0.6,0.9C143.4,376.9,143.2,376.9,143,376.9z M140.7,375.8c1.2,0.6,2.2,0.9,2.7,0.6 c0.2-0.1,0.3-0.3,0.4-0.6c0-0.2,0-0.2-0.1-0.3C143.3,375.3,141.8,375.5,140.7,375.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M140.2,376c-0.1,0-0.1,0-0.1-0.1c0,0-0.1-0.1,0-0.2c0-0.1,0.7-2.3,1.7-2.8c0.3-0.1,0.6-0.1,0.8,0 c0.4,0.2,0.5,0.5,0.5,0.7C143,374.5,141.1,375.8,140.2,376C140.3,376,140.3,376,140.2,376z M142.2,373.2c-0.1,0-0.2,0-0.3,0.1 c-0.6,0.3-1.1,1.5-1.4,2.2c0.9-0.4,2.1-1.4,2.1-1.9c0-0.1,0-0.2-0.2-0.3C142.3,373.3,142.3,373.2,142.2,373.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M157.3,381.2c-1.1,0-2.7-1.4-3.6-2.3c-0.1-0.1-0.1-0.1,0-0.2c0-0.1,0.1-0.1,0.2-0.1 c0.4,0.1,3.9,0.5,4.4,1.5c0.1,0.2,0.1,0.4,0,0.6c-0.2,0.3-0.5,0.5-0.8,0.6C157.4,381.2,157.3,381.2,157.3,381.2z M154.4,379 c1.3,1.2,2.4,1.9,3,1.8c0.2,0,0.4-0.1,0.5-0.4c0-0.1,0.1-0.2,0-0.2C157.6,379.7,155.8,379.3,154.4,379z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M154.5,379c-0.3,0-0.5,0-0.7-0.1c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0.1-0.1,1.4-1.7,2.7-1.8 c0.4,0,0.7,0.1,1,0.3c0.4,0.3,0.4,0.6,0.3,0.8C157.4,378.7,155.6,379,154.5,379z M154.2,378.6c1.1,0.1,2.9-0.3,3.1-0.8 c0,0,0.1-0.2-0.2-0.4c-0.2-0.2-0.5-0.3-0.8-0.2C155.6,377.3,154.6,378.2,154.2,378.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M140.5,374.9l-8.5-2.4c-0.3-0.1-0.6,0.1-0.7,0.3l-2.9,6.4c-0.3,0.7,0.1,1.5,0.8,1.7c3,0.8,4.4,1,8.2,2.1 c2.3,0.6,5.6,1.8,8.7,2.7c3.1,0.9,4.2-2.2,3-2.8c-5.6-2.9-6-5-7.5-7.2C141.4,375.3,141,375,140.5,374.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.9,377.7l-7.2-5c-0.3-0.2-0.6-0.1-0.8,0.1l-4.8,5.2c-0.5,0.5-0.4,1.5,0.2,1.9c2.6,1.7,3.9,2.4,7.1,4.6 c2,1.4,5.9,4.4,8.6,6.3c2.6,1.8,4.7-0.7,3.7-1.7c-4.3-4.6-5.2-7.5-6-10.1C154.6,378.4,154.3,378,153.9,377.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "148.1,368.4 135,361.9 136.4,358.4 150.3,365.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M131.1,246.1L130,249c-0.1,0.2,0.2,0.4,0.5,0.4h33.1c0.3,0,0.5-0.1,0.5-0.3l0.3-2.9c0-0.2-0.2-0.4-0.5-0.4 h-32.3C131.4,245.9,131.2,246,131.1,246.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M131.1,246.1L130,249c-0.1,0.2,0.2,0.4,0.5,0.4h33.1c0.3,0,0.5-0.1,0.5-0.3l0.3-2.9c0-0.2-0.2-0.4-0.5-0.4 h-32.3C131.4,245.9,131.2,246,131.1,246.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.3,249.7h-0.9c-0.2,0-0.3-0.1-0.3-0.2l0.4-3.7c0-0.1,0.2-0.2,0.3-0.2h0.9c0.2,0,0.3,0.1,0.3,0.2 l-0.4,3.7C136.6,249.6,136.5,249.7,136.3,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M156.7,249.7h-0.9c-0.2,0-0.3-0.1-0.3-0.2l0.4-3.7c0-0.1,0.2-0.2,0.3-0.2h0.9c0.2,0,0.3,0.1,0.3,0.2 l-0.4,3.7C157,249.6,156.9,249.7,156.7,249.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.8,417.1c0,1.1,11.9,1.9,26.7,1.9c14.8,0,26.8-0.9,26.9-1.9c0-1.1-11.9-1.9-26.7-1.9 C120.8,415.2,108.8,416.1,108.8,417.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,414.4c-4.7-1.4-10-3.1-13.2-5c-0.1-0.1-0.2-0.1-0.3-0.1v-21.4h9.5c1.6,0,2.9-1.3,2.9-2.9 c0-1.6-1.3-2.9-2.9-2.9h-9.5v-97.8h-5.7v97.8h-9.5c-1.6,0-2.9,1.3-2.9,2.9c0,1.6,1.3,2.9,2.9,2.9h9.5v21.4 c-0.1,0-0.2,0.1-0.3,0.1c-3.2,1.9-8.4,3.7-13.2,5c-1.6,0.5-1.2,2.7,0.4,2.7h15.9h15.9C153.1,417.1,153.4,414.9,151.9,414.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M153.3,295.2h-35.6c-2.8,0-5.2-2.3-5.2-5.2v-10.6c0-2.8,2.3-5.2,5.2-5.2h35.6c2.8,0,5.2,2.3,5.2,5.2v10.6 C158.5,292.9,156.2,295.2,153.3,295.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M117.4,295.2v1.8c0,1.5,1.6,2.7,3.6,2.7h29c2,0,3.6-1.2,3.6-2.7v-1.8H117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M117.4,295.2v1.8c0,1.5,1.6,2.7,3.6,2.7h29c2,0,3.6-1.2,3.6-2.7v-1.8H117.4z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.b49c165bce3b57650dcdc7f066682cff.svg";
export { ForwardRef as ReactComponent };